import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { default as TooltipButton } from 'react-bootstrap/Button';

/* Components */
import FlowFieldSelect from 'conversie-flow-bundle/assets/js/components/flow/fields/FlowFieldSelect';

/* Common */
import { Icon } from '~/components/common';

/* Icons */
import InfoIcon from '~/../symbols/info-circle.svg';

export default function ConversionFieldSelect(props) {
    const { field } = props;

    return (
        <div className="row gutters-0 mb-5">
            <div className="col-12">
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <label htmlFor={props.id} className="flow__label">
                        {field?.label}
                    </label>
                    {field?.config?.tooltip && (
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id={`tooltip-${field.name}`}>
                                    {field.config.tooltip}
                                </Tooltip>
                            }
                        >
                            <TooltipButton
                                variant="none"
                                className="ml-1 p-0 mt-0"
                            >
                                <Icon
                                    theme="base"
                                    size={16}
                                    url={InfoIcon?.url}
                                    className={`icon--tooltip`}
                                />
                            </TooltipButton>
                        </OverlayTrigger>
                    )}
                </div>
                <FlowFieldSelect
                    {...props}
                    field={{
                        ...field,
                        label: null,
                    }}
                    colClassName=""
                    inputType="select"
                />
            </div>
        </div>
    );
}
